<template>
  <nav class="sticky top-0 xl:top-2 z-20 mx-auto max-w-screen-xl w-full">
      <div
        class="px-4 lg:px-8 xl:-mx-8 lg:rounded-b xl:rounded-t py-1 xl:py-2 transition-shadow"
        :class="{ 'bg-white dark:bg-gray-900 shadow-2xl': !view.atTopOfPage }"
      >
        <slot />
      </div>
  </nav>
</template>
<script>
export default {
  name: 'StickyNav',
  data () {
    return {
        view: {
            atTopOfPage: true
        }
    }
  },

  // a beforeMount call to add a listener to the window
  beforeMount () {
      window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
  	// the function to call when the user scrolls, added as a method
      handleScroll(){
          // when the user scrolls, check the pageYOffset
          if(window.pageYOffset>0){
              // user is scrolled
              if(this.view.atTopOfPage) this.view.atTopOfPage = false
          }else{
              // user is at top of page
              if(!this.view.atTopOfPage) this.view.atTopOfPage = true
          }
      }
  }
}
</script>
